package io.horion.cv.components.preview

import androidx.compose.runtime.Composable
import io.horion.cv.uiState.LetterUiState
import io.horion.cv.utils.orDefault
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

@Composable
fun LetterAdvancePreview(letterUiState: LetterUiState){
    Div(attrs = {
        style {
            property("width", "794px")
            property("min-height", "1123px")
            property("font-family", "Georgia, serif")
            property("font-size", "18px")
            property("background", "#ffffff")
            property("color", "#000000")
            property("padding", "50px 60px")
            property("box-sizing", "border-box")

            // ✅ Ajout uniquement de ces 4 propriétés pour le retour à la ligne
            property("word-wrap", "break-word")
            property("overflow-wrap", "break-word")
            property("white-space", "normal")
            property("word-break", "break-word")
        }
    }) {

        // Nom prenom
        Text( letterUiState.data.personalInformation.lastName.orDefault("prenom"))
        Br {}
        Div(attrs = {
            style {
                property("font-weight", "bold")
                property("text-transform", "uppercase")
            }
        }) {
            Text(letterUiState.data.personalInformation.firstName.uppercase().orDefault("NOM ") )
        }
        Br {}

        // Code postal,adresse
        Text(letterUiState.data.personalInformation.bp.orDefault("codePostal ") +", "+ letterUiState.data.personalInformation.address.orDefault("Ville "))
        Br {}



        // numero de telephone
        Text(letterUiState.data.personalInformation.phone.orDefault("Numero , "))
        //adresse email
        Text( ", "+letterUiState.data.personalInformation.email.orDefault("adresse email"))
        Br {}

        //entreprise a droite
        Div(attrs = {
            style {
                property("text-align", "right")
            }
        }) {
            Text("Monsieur le directeur des ressources humaines de ")
            Br {}
            Text(letterUiState.enterprise.orDefault("Entreprise "))
            Br {}

            // ville ,Date
            Text(letterUiState.data.personalInformation.city.orDefault("Ville ")+ ", "+ letterUiState.data.date.orDefault("Date "))
            Br {}
        }

        Br {}

        // Objet
        Div(attrs = {
            style {
                property("font-weight", "bold")
            }
        }) {
            Text("Objet : "+ letterUiState.data.subject)
        }
        Br {}
        Br {}
// 1er paragraphe INTRODUCTION
        HtmlBlock(letterUiState.data.introduction) {
            property("overflow-wrap", "break-word")
        }
        Br {}
        Br {}

// 2e paragraphe SITUATION
        HtmlBlock(letterUiState.data.situation) {
            property("overflow-wrap", "break-word")
        }
        Br {}
        Br {}

// 3e paragraphe MOTIVATION
        HtmlBlock(letterUiState.data.motivation) {
            property("overflow-wrap", "break-word")
        }
        Br {}
        Br {}

// Remerciement CONCLUSION
        HtmlBlock(letterUiState.data.conclusion) {
            property("overflow-wrap", "break-word")
        }
        Br {}
        Br {}        // Formule de politesse
        Text("Veuillez agréer, Madame, Monsieur, l’expression de mes salutations distinguées.")
        Br {}
        Br {}

        // piece jointe
        Div(attrs = {
            style {
                property("text-decoration", "underline")
            }
        }) {
            Text("Pieces Jointes : ")
        }
        Br {}
        Div(attrs = {
            style {
                property("margin-top", "10px")
                property("margin-bottom", "10px")
            }
        }) {
            Ul {
                letterUiState.data.others.forEach { item ->
                    Li {
                        Text(item)
                    }
                }
            }
        }

        //nom et prenom
        Text(letterUiState.data.personalInformation.firstName.orDefault("Nom").uppercase() +" "+ letterUiState.data.personalInformation.lastName.orDefault("prenom") )

    }
}